import React from 'react';
import PullStation, { StationProps } from './PullStation';
import ReachedOutNode, { ReachedOutNodeProps } from './ReachedOutNode';
import css from './PullTrack.module.scss';

interface PullTrackProps {
  searches: StationProps;
  opportunities: StationProps;
  reached: ReachedOutNodeProps;
  replies: StationProps;
  process: StationProps;
  /** Index (0–4) of the right-most stage the user has reached; drives the green fill. */
  filledThrough: number;
}

const Connector: React.FC<{ filled: boolean }> = ({ filled }) => (
  <span className={`${css.connector} ${filled ? css.connectorFilled : ''}`} aria-hidden="true" />
);

/**
 * The pull track: five connected stations telling the human-pull journey. The
 * line fills green from the left up to the furthest stage reached; the amber
 * "Reached out" node sits at the centre.
 */
const PullTrack: React.FC<PullTrackProps> = ({
  searches,
  opportunities,
  reached,
  replies,
  process,
  filledThrough,
}) => (
  <section className={css.trackCard} aria-label="Your job-search journey">
    <div className={css.track}>
      <PullStation {...searches} dimmed={false} />
      <Connector filled={filledThrough > 0} />
      <PullStation {...opportunities} dimmed={filledThrough < 1} />
      <Connector filled={filledThrough > 1} />
      <ReachedOutNode {...reached} />
      <Connector filled={filledThrough > 2} />
      <PullStation {...replies} dimmed={filledThrough < 3} />
      <Connector filled={filledThrough > 3} />
      <PullStation {...process} dimmed={filledThrough < 4} />
    </div>
  </section>
);

export default PullTrack;
